import Vue from 'vue';

// local state
const getDefaultState = () => {
    return {
//        fans: [],
        selectedFans: [],
//        accessories: [],
        selectedAccessories: [],

        table_fields_cart: [
           /*  { key: 'id', label: '' }, */
            { key: 'position', label: 'lang.shoppingcart.tablecolheader.position' },
            { key: 'image', label: '' },
            { key: 'ref_no', label: 'lang.shoppingcart.tablecolheader.refno' },
            { key: 'description_short', label: 'lang.global.product.tabs.techdata.desc_short' },
            { key: 'wg', label: 'lang.global.product.tabs.accessories.wg' },
            { key: 'quantity', label: 'lang.addtocart.quantity' },
            { key: 'listprice', label: 'lang.shoppingcart.tablecolheader.listprice'},
            { key: 'price', label: 'lang.shoppingcart.tablecolheader.price'},
            { key: 'discount_1', label: 'lang.shoppingcart.tablecolheader.discount1' },
            { key: 'discount_2', label: 'lang.shoppingcart.tablecolheader.discount2' },
            { key: 'productmarker', label: 'lang.shoppingcart.tablecolheader.productmarker' },
            { key: 'totalprice', label: 'lang.shoppingcart.tablecolheader.pricetotal' },
            { key: 'info', label: '' },
            { key: 'description_long', label: '' },
        ],
        shoppingcartlist: [],
        addpositiontext_options: [
            { value: 0, text: 'lang.shoppingcart.position.rb0', disabled: false },
            { value: 1, text: 'lang.shoppingcart.position.rb1', disabled: false },
            { value: 2, text: 'lang.shoppingcart.position.rb2', disabled: false }
        ],

        /* save_options:[
            { value: 0, text: 'lang.shoppingcart.save.options.rb0' },
            { value: 1, text: 'lang.shoppingcart.save.options.rb1' },
            { value: 2, text: 'lang.shoppingcart.save.options.rb2' }
        ], */
        search_flag: '',
        shoppingcartnetto: '',
        reRenderShoppingcart: 0




    }
};


const state = getDefaultState()

const getters = {

};

const mutations = {
    resetState(state) {
        Object.assign(state, getDefaultState())
    },
    removeCartItem(state, item) {
        state.shoppingcartlist.splice(item.index, 1);
    },
    updateShoppingcartList(state, products) {
        /*console.log('updateShoppingcartList products:')
        console.log(products)*/
        state.shoppingcartlist = products
    },
    updateShoppingcartnetto(state, sum) {
        state.shoppingcartnetto = sum
    },
    removeCart(state) {
        for (var i = state.shoppingcartlist.length - 1; i >= 0; i--) {
            state.shoppingcartlist.splice(i, 1);
        }
    },
    updatePositiontextOptions(state, options) {
        state.addpositiontext_options = options
    },
    updateSearchFlag(state, flag) {
        state.search_flag = flag
    },
    update(state, flag) {
        state.search_flag = flag
    },
    updatereRenderShoppingcart(state, value) {
        state.reRenderShoppingcart = value
    },



};

const actions = {
    resetState({ commit }) {
        commit('resetState')
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
